module.exports = __webpack_public_path__ + "img/108.885b6aed.jpg";